import Vue from 'vue';
import PageBase from '@glittr/frontend-core/src/core/v2/app/pageBase';
import WelcomeFormPayloadResourceViewModel from '@/src/services/v1/viewModel/resource/WelcomeFormPayloadResourceViewModel';
import GetWelcomeFormPayloadRequestViewModel from '@/src/services/v1/viewModel/request/WelcomeForm/GetWelcomeFormPayloadRequestViewModel';
import PostWelcomeFormPayloadRequestModel from '@/src/services/v2/model/post-welcome-form-payload-request-model';
import welcomeSchema from './welcome.vue.model.schema';

interface CheckBoxItem {
  id : string;
  caption:string;
}

export default class CampaignEventVM extends PageBase {
  // Widget Configuration to model properties
  contactId: string = '';
  tenantKey: string = 'kls';
  submitRedirectUrl: string = '#';

  // State properties
  isLoading: boolean = true;
  isSubmitting: boolean = false;
  isSubmitted: boolean = false;
  error: any;

  // Form properties
  formSummary: any = {};
  formPayload: PostWelcomeFormPayloadRequestModel = new PostWelcomeFormPayloadRequestModel();
  newsletterItems: CheckBoxItem[] = [];
  characteristicItems: CheckBoxItem[] = [];
  availableNewsletterOptions: string[] = [];

  // form state
  isContactDataPrefilled: boolean = false;

  async initialize(): Promise<void> {
    this.formPayload.schema = welcomeSchema;
    try {
      await this.initializeFormPayload();
      await this.initializeFormNewsletter();
      await this.initializeFormGiftItems();
    } catch (error) {
      this.error = error;
    } finally {
      this.isLoading = false;
    }
  }
  async initializeFormPayload() {
    const req = new GetWelcomeFormPayloadRequestViewModel();
    req.contactId = this.contactId;
    // extract the dto and inject into new viewmodel to have a 'real' viewmodel that can be sent to backend again
    const backendPayloadVM = await Vue.$service.v1.api.welcomeForm.getWelcomeFormPayload(req);
    const backendPayloadDTO = backendPayloadVM.toDTO();
    const formPayloadVM = new WelcomeFormPayloadResourceViewModel().fromDTO(backendPayloadDTO);
    this.formPayload.contact = {};
    if (formPayloadVM !== undefined) {
      if (formPayloadVM.dynamicFormPayloadResource !== undefined && formPayloadVM.dynamicFormPayloadResource.contact !== undefined) {
        if (formPayloadVM.dynamicFormPayloadResource.contact.firstName) { Vue.set(this.formPayload.contact, 'firstName', formPayloadVM.dynamicFormPayloadResource.contact.firstName); }
        if (formPayloadVM.dynamicFormPayloadResource.contact.lastName) { Vue.set(this.formPayload.contact, 'lastName', formPayloadVM.dynamicFormPayloadResource.contact.lastName); }
        if (formPayloadVM.dynamicFormPayloadResource.contact.street) { Vue.set(this.formPayload.contact, 'street', formPayloadVM.dynamicFormPayloadResource.contact.street); }
        if (formPayloadVM.dynamicFormPayloadResource.contact.houseNumber) { Vue.set(this.formPayload.contact, 'houseNumber', formPayloadVM.dynamicFormPayloadResource.contact.houseNumber); }
        if (formPayloadVM.dynamicFormPayloadResource.contact.city) { Vue.set(this.formPayload.contact, 'city', formPayloadVM.dynamicFormPayloadResource.contact.city); }
        if (formPayloadVM.dynamicFormPayloadResource.contact.postalCode) { Vue.set(this.formPayload.contact, 'postalCode', formPayloadVM.dynamicFormPayloadResource.contact.postalCode); }
        if (formPayloadVM.dynamicFormPayloadResource.contact.eMail) { Vue.set(this.formPayload.contact, 'eMail', formPayloadVM.dynamicFormPayloadResource.contact.eMail); }
        if (formPayloadVM.dynamicFormPayloadResource.contact.phoneNumber) { Vue.set(this.formPayload.contact, 'phoneNumber', formPayloadVM.dynamicFormPayloadResource.contact.phoneNumber); }
        if (formPayloadVM.dynamicFormPayloadResource.contact.mobilePhoneNumber) { Vue.set(this.formPayload.contact, 'mobilePhoneNumber', formPayloadVM.dynamicFormPayloadResource.contact.mobilePhoneNumber); }
        this.isContactDataPrefilled = true;
      }
      // newsletter
      if (formPayloadVM.availableNewsletters !== undefined && formPayloadVM.availableNewsletters !== null) {
        this.formPayload.newsletterItems = formPayloadVM.selectedNewsletters?.map(String);
      }
      if (formPayloadVM.availableNewsletters !== undefined && formPayloadVM.availableNewsletters !== null) {
        this.availableNewsletterOptions = formPayloadVM.availableNewsletters;
      }
    }
  }
  async initializeFormNewsletter() {
    this.availableNewsletterOptions.forEach((key) => {
      let keyWithoutSort = key;
      if (key.indexOf('_') > 0) {
        const [sortString, keyString] = key.split('_');
        keyWithoutSort = keyString;
      }
      const option = {
        id: key,
        caption: Vue.$t(`widget.welcome.newsletter.${this.tenantKey}.${keyWithoutSort}`),
      };
      this.newsletterItems.push(option);
    });
  }

  async initializeFormGiftItems() {
    this.characteristicItems = [];
    const gift = {
      id: 'gift',
      caption: Vue.$t(`widget.welcome.characteristic.${this.tenantKey}.gift`),
    } as CheckBoxItem;
    this.characteristicItems.push(gift);
  }

  // submit
  get canSubmitForm() { return !this.isSubmitting; }
  async submitForm() {
    this.isSubmitting = true;
    try {
      if (!this.formPayload.validate()) {
        this.isSubmitting = false;
        return;
      }
      this.formPayload.languageIso2 = Vue.$translation.get() ?? Vue.$config.values['language-default'];
      this.formPayload.contactId = this.contactId;
      this.formPayload.tenantKey = this.tenantKey;
      const req = this.formPayload;
      await Vue.$service.v2.api.welcomeForm.postWelcomeFormPayload(req);
      this.isSubmitted = true;
      if (this.submitRedirectUrl !== undefined && this.submitRedirectUrl !== '') {
        window.location.href = this.submitRedirectUrl;
      }
    } catch (error: any) {
      this.error = error;
    }
    this.isSubmitting = false;
  }
}
